import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaGithub, FaLinkedinIn, FaTwitter, FaInstagram, FaEnvelope, FaDownload } from "react-icons/fa";
import { FiCopy, FiCheck } from "react-icons/fi";
import { personalInfo } from "../data/portfolioData";
import logoImg from "../Assets/logo.png";
import pdfCV from "../Assets/MRayyanCV.pdf";

function Footer() {
  const [copied, setCopied] = useState(false);
  const currentYear = new Date().getFullYear();

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(personalInfo.email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <footer className="modern-footer-wrapper">
      <Container>
        <div className="footer-top-grid">
          {/* Col 1: Brand & Bio */}
          <div className="footer-brand-col text-start">
            <div className="footer-brand-header">
              <img src={logoImg} alt="Logo" className="footer-logo-img" />
              <div>
                <h4>{personalInfo.name}</h4>
                <p className="footer-role">{personalInfo.title}</p>
              </div>
            </div>
            <p className="footer-bio-text">
              Specialized in engineering high-performance React Native mobile applications, Web3 dApps, and scalable backend microservices.
            </p>
            <div className="footer-location-tag">
              📍 {personalInfo.location} • Available Worldwide (Remote / Contract)
            </div>
          </div>

          {/* Col 2: Navigation Links */}
          <div className="footer-nav-col text-start">
            <h5>Navigation</h5>
            <ul className="footer-links-list">
              <li><Link to="/">Home Overview</Link></li>
              <li><Link to="/project">Featured Apps & Systems</Link></li>
              <li><Link to="/about">About & Skills Matrix</Link></li>
              <li>
                <a href={pdfCV} download="Rayyan_Waseem_CV.pdf" target="_blank" rel="noopener noreferrer">
                  <FaDownload className="me-1" /> Download PDF Resume
                </a>
              </li>
            </ul>
          </div>

          {/* Col 3: Direct Contact */}
          <div className="footer-contact-col text-start">
            <h5>Direct Contact</h5>
            <p className="footer-contact-subtext">
              Have an app idea or looking for an experienced React Native developer? Let's connect!
            </p>
            <div className="d-flex flex-column gap-2 mt-3">
              <button className={`footer-copy-btn ${copied ? "copied" : ""}`} onClick={handleCopyEmail}>
                {copied ? <FiCheck className="text-emerald" /> : <FiCopy />}
                <span>{copied ? "Email Copied!" : personalInfo.email}</span>
              </button>
              <a href={`mailto:${personalInfo.email}`} className="btn-modern primary footer-email-direct-btn">
                <FaEnvelope /> <span>Send Email</span>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom-bar">
          <p className="footer-copyright">
            © {currentYear} {personalInfo.name}. All rights reserved.
          </p>

          <div className="footer-social-icons">
            <a href={personalInfo.socials.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href={personalInfo.socials.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
            <a href={personalInfo.socials.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href={personalInfo.socials.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
